// extracted by mini-css-extract-plugin
export default {"pagination-container":"Pagination_pagination-container__6pALb","active":"Pagination_active__7hVQj"};